import { createContext, useContext } from 'react'

type IsNewSeller = (storefrontId: string) => boolean

/**
 * Shares the list view's `isNewSeller` lookup with the AG Grid cell renderers.
 * A React context rather than the grid's `context` option, which AG Grid
 * reads only on mount (`@initial`): the new-seller storefront set usually
 * loads after the grid mounts, so a grid-context lookup stayed `false`.
 */
const ListViewNewSellerContext = createContext<IsNewSeller>(() => false)

export const ListViewNewSellerProvider = ListViewNewSellerContext.Provider

export const useListViewIsNewSeller = (): IsNewSeller =>
  useContext(ListViewNewSellerContext)
